<template>
  <CreateUpdateTemplate
    :routePreventDialog="routePreventDialog"
    :customClass="'customer-create create-form'"
    v-if="getPermission('customer:create')"
  >
    <template v-slot:header-title>
      <h1 class="form-title d-flex">
        Create a new Customer
        <SystemGenerateId
          v-if="barcode"
          :system-id="barcode"
        ></SystemGenerateId>
      </h1>
    </template>
    <template v-slot:header-action>
      <v-btn
        v-on:click="goBack"
        :disabled="formLoading"
        depressed
        class="mx-2 custom-grey-border custom-bold-button"
      >
        Cancel
      </v-btn>

      <v-btn
        :disabled="
          steps.billing || !formValid || formLoading || isBillingValidated
        "
        :loading="formLoading"
        depressed
        class="mx-2 custom-bold-button white--text"
        v-on:click="onSubmit"
        color="cyan"
      >
        Save Customer
      </v-btn>
    </template>
    <template v-slot:body>
      <v-form
        ref="customerForm"
        v-model.trim="formValid"
        lazy-validation
        v-on:submit.stop.prevent="onSubmit"
      >
        <v-tabs
          v-model="customerTab"
          background-color="transparent"
          centered
          color="cyan"
          fixed-tabs
          grow
          class="custom-tab-transparent"
          hide-slider
        >
          <template v-for="(tab, index) in tabs">
            <v-tab
              class="font-size-16 font-weight-600 px-8"
              v-if="getPermission(tab.permission + ':create')"
              :key="index"
              :disabled="steps[tab.key]"
              :href="'#tab-' + tab.key"
            >
              <v-icon color="grey darken-4" left>{{ tab.icon }}</v-icon>
              {{ tab.title }}
            </v-tab>
          </template>
        </v-tabs>
        <v-tabs-items v-model="customerTab">
          <v-tab-item :value="'tab-details'">
            <ContactDetails
              :lead="lead"
              v-on:saveContactDetail="updateContactDetail"
              v-on:displayNameUnique="handleDisplayNameUnique"
              :options="options"
              :customer-code="customerCode"
              @get-customer-payment-term="getOptions"
            ></ContactDetails>
          </v-tab-item>
          <v-tab-item
            v-if="getPermission('contact-person:create')"
            :value="'tab-contact-person'"
          >
            <ContactPersons
              v-bind:detail="contactDetail"
              :persons="contactPersons"
              v-on:saveContactPerson="updateContactPerson"
            ></ContactPersons>
          </v-tab-item>
          <v-tab-item
            v-if="getPermission('property:create')"
            :value="'tab-property'"
          >
            <PropertyAddress
              :lead="lead"
              :options="options"
              is-customer-from
              v-bind:billing="billingAddress"
              v-on:savePropertyAddress="updatePropertyAddress"
            ></PropertyAddress>
          </v-tab-item>
          <v-tab-item :value="'tab-billing'">
            <BillingAddress
              :lead="lead"
              :options="options"
              v-bind:property="propertyAddress"
              v-on:saveBillingAddress="updateBillingAddress"
            ></BillingAddress>
          </v-tab-item>
          <v-tab-item :value="'tab-notification'">
            <Notification
              :options="options"
              v-on:saveNotification="updateNotification"
            ></Notification>
          </v-tab-item>

          <v-tab-item :value="'tab-attachment'">
            <v-col md="12" class="pb-0">
              <DocumnetList v-model="attachments"> </DocumnetList>
            </v-col>
          </v-tab-item>
        </v-tabs-items>
      </v-form>
    </template>
  </CreateUpdateTemplate>
</template>

<script>
import { mapGetters } from "vuex";
import CommonMixin from "@/core/plugins/common-mixin";
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_CC_PERSONS } from "@/core/services/store/common.module";
import DocumnetList from "@/view/pages/DocumnetList";
import {
  POST,
  PUT,
  CLEAR_ERROR,
  GET,
} from "@/core/services/store/request.module";
import SystemGenerateId from "@/view/pages/partials/SystemGenerateId.vue";
import ContactDetails from "@/view/pages/customer/create-or-update/Contact-Details.vue";
import ContactPersons from "@/view/pages/customer/create-or-update/Contact-Persons.vue";
import PropertyAddress from "@/view/pages/customer/create-or-update/Property-Address.vue";
import BillingAddress from "@/view/pages/customer/create-or-update/Billing-Address.vue";
import Notification from "@/view/pages/customer/create-or-update/Notification.vue";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";

export default {
  mixins: [CommonMixin],
  name: "customer-create",
  title: "Create Customer",
  data() {
    return {
      leadId: 0,
      lead: {},
      contactPersons: [],
      paymentTermsList: [],
      propertyAddress: {},
      billingAddress: {},
      barcode: null,
      customerCode: null,
      contactDetail: {},
      contactPerson: [],
      notification: {},
      attachments: [],
      usersList: [],
      tabs: [
        {
          title: "Contact Details",
          icon: "mdi-phone",
          key: "details",
          permission: "customer",
        },
        {
          title: "Contact Persons",
          icon: "mdi-account-multiple",
          key: "contact-person",
          permission: "contact-person",
        },
        {
          title: "Address",
          icon: "mdi-home-map-marker",
          key: "property",
          permission: "property",
        },
        {
          title: "Billing Address",
          icon: "mdi-credit-card",
          key: "billing",
          permission: "customer",
        },
        {
          title: "Attachments",
          icon: "mdi-attachment",
          key: "attachment",
          permission: "customer",
        },
        /* {
          title: "Remarks",
          icon: "mdi-bell-ring",
          key: "notification",
          permission: "customer",
        }, */
      ],
      customerTab: "tab-details",
      isCustomerCreated: false,
      isAddressCreated: false,
      customerId: 0,
      options: {},
      steps: {
        details: false,
        "contact-person": true,
        property: true,
        billing: true,
        notification: true,
        attachment: true,
      },
      displayNameIsUnique: false,
      isBillingValidated: true,
    };
  },
  components: {
    ContactDetails,
    ContactPersons,
    PropertyAddress,
    BillingAddress,
    Notification,
    CreateUpdateTemplate,
    SystemGenerateId,
    DocumnetList,
  },
  watch: {
    customerTab() {
      const _this = this;
      setTimeout(function () {
        _this.$refs.customerForm.validate();
        _this.$nextTick(() => {
          _this.activateTab();
        });
      }, 200);
    },
    formValid(param) {
      if (param) {
        this.activateTab();
        this.$store.dispatch(CLEAR_ERROR, {});
      }
    },
  },
  methods: {
    activateTab() {
      if (this.formValid) {
        if (this.customerTab == "tab-details") {
          const categorySet = !!(
            this.contactDetail && this.contactDetail.category
          );
          const nameSet = !!(
            this.contactDetail &&
            (this.contactDetail.first_name || this.contactDetail.last_name)
          );
          this.steps["contact-person"] = !(
            this.displayNameIsUnique &&
            categorySet &&
            nameSet
          );
        }

        if (this.customerTab == "tab-contact-person") {
          this.steps["property"] = false;
        }

        if (this.customerTab == "tab-property") {
          const addr = this.propertyAddress || {};
          const countryIsSG = addr.country == "singapore";
          const contactSet = !!addr.contact_person;
          const postalSet = !!(addr.zip_code && String(addr.zip_code).trim());
          // const zoneSet = !!addr.zone_territory;
         const unitAndLineSet = !countryIsSG || !!addr.unit_no;
          // const billingReady =
          //   contactSet && postalSet && zoneSet && unitAndLineSet;
          const billingReady = contactSet && postalSet && unitAndLineSet;
          this.steps["billing"] = !billingReady;
        }

        if (this.customerTab == "tab-billing") {
          this.steps["notification"] = false;
          this.isBillingValidated = false;
          this.steps["attachment"] = false;
          //this.steps["billing"] = false;
        }

        // if (this.customerTab == "tab-attachment") {
        //   this.steps["attachment"] = false;
        // }
      }
    },
    updatePropertyAddress(param) {
      this.propertyAddress = param;
      const addr = this.propertyAddress || {};
      const countryIsSG = addr.country == "singapore";
      const contactSet = !!addr.contact_person;
      const postalSet = !!(addr.zip_code && String(addr.zip_code).trim());
      // const zoneSet = !!addr.zone_territory;

      const unitAndLineSet = !countryIsSG || !!addr.unit_no;
      const billingReady = contactSet && postalSet && unitAndLineSet;
      // const billingReady = contactSet && postalSet && zoneSet && unitAndLineSet;
      this.steps["billing"] = !billingReady;
    },
    updateBillingAddress(param) {
      this.billingAddress = param;
    },
    updateContactDetail(param) {
      this.contactDetail = param;
      // recompute whether contact-person tab should be disabled
      const categorySet = !!(this.contactDetail && this.contactDetail.category);
      const nameSet = !!(
        this.contactDetail &&
        (this.contactDetail.first_name || this.contactDetail.last_name)
      );
      this.steps["contact-person"] = !(
        this.displayNameIsUnique &&
        categorySet &&
        nameSet
      );
    },
    updateContactPerson(param) {
      this.contactPerson = param;
      this.$store.dispatch(SET_CC_PERSONS, param);
    },
    updateNotification(param) {
      this.notification = param;
    },
    handleDisplayNameUnique(isUnique) {
      this.displayNameIsUnique = !!isUnique;
      const categorySet = !!(this.contactDetail && this.contactDetail.category);
      const nameSet = !!(
        this.contactDetail &&
        (this.contactDetail.first_name || this.contactDetail.last_name)
      );
      this.steps["contact-person"] = !(
        this.displayNameIsUnique &&
        categorySet &&
        nameSet
      );
    },
    getOptions() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "customer/options" })
        .then(({ data }) => {
          _this.options = data.options;
          _this.barcode = data.barcode;
          _this.options.allow_zones = data.allow_zones;
          _this.options.active_zones = data.active_zones;
          _this.options.all_tags = data.all_tags;
          _this.options.all_cms_categories = data.all_cms_categories;
          _this.options.userList = data.userList;
          _this.customerCode = data.customer_code;

          _this.options.paymentTermsList = data.customer_payment_terms;
        })
        .catch((error) => {
          _this.logError(error);
        });
      /*.finally(() => {
          _this.$refs.customerForm.validate();
        });*/
    },
    createOrUpdatedAddress(customer) {
      return new Promise((resolve, reject) => {
        try {
          if (customer) {
            const _this = this;
            const addressArr = [];
            if (_this.lodash.isEmpty(_this.propertyAddress) === false) {
              addressArr.push(_this.propertyAddress);
            }
            if (_this.lodash.isEmpty(_this.billingAddress) === false) {
              addressArr.push(_this.billingAddress);
            } else {
              addressArr.push({
                id: _this.propertyAddress.id || null,
                contact_person: _this.propertyAddress.contact_person || null,
                property_name: _this.propertyAddress?.property_name || null,
                type: 2,
                is_same: 1,
                is_tenant: _this.propertyAddress.is_tenant || 0,
                unit_no: _this.propertyAddress.unit_no || null,
                street_1: _this.propertyAddress.street_1 || null,
                street_2: _this.propertyAddress.street_2 || null,
                zip_code: _this.propertyAddress.zip_code || null,
                country: _this.propertyAddress.country || null,
                latitude: _this.propertyAddress.latitude || null,
                longitude: _this.propertyAddress.longitude || null,
                remarks: _this.propertyAddress.remarks || null,
              });
            }

            if (_this.lodash.isEmpty(addressArr) === false) {
              const formData = { address: addressArr };
              _this.$store
                .dispatch(PUT, { url: "address/" + customer, data: formData })
                .then((response) => {
                  resolve(response);
                })
                .catch((error) => {
                  reject(error);
                });
            } else {
              resolve(true);
            }
          } else {
            resolve(true);
          }
        } catch (error) {
          reject(error);
        }
      });
    },
    makeDefaultPerson() {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          let emailData = _this.lodash.filter(
            _this.contactDetail.details,
            function (data) {
              return data.type === 1;
            }
          );
          let contactData = _this.lodash.filter(
            _this.contactDetail.details,
            function (data) {
              return data.type === 2;
            }
          );
          let firstEntry = {
            id: null,
            title: _this.contactDetail.salutation,
            first_name: _this.contactDetail.first_name,
            last_name: _this.contactDetail.last_name,
            will_notified: 1,
            position: null,
            did: _this.contactDetail.did,
            display_name: _this.createDisplayName(),
            primary_email: _this.lodash.head(emailData)
              ? _this.lodash.head(emailData).value
              : null,
            primary_phone: _this.lodash.head(contactData)
              ? _this.lodash.head(contactData).value
              : null,
            default: 1,
          };
          resolve([firstEntry]);
        } catch (error) {
          reject(error);
        }
      });
    },
    createDisplayName() {
      const _this = this;
      let firstname = "";
      if (_this.contactDetail.first_name) {
        firstname = _this.contactDetail.first_name.toLowerCase();
      }
      let lastname = "";
      if (_this.contactDetail.last_name) {
        lastname = _this.contactDetail.last_name.toLowerCase();
      }
      return firstname + lastname;
    },
    async onSubmit() {
      const _this = this;
      try {
        const formErrors = _this.validateForm(_this.$refs.customerForm);
        if (formErrors && formErrors.length) {
          for (let i = 0; i < formErrors.length; i++) {
            ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
          }
          return false;
        }

        /*if (_this.lodash.isEmpty(_this.billingAddress)) {
          _this.customerTab = "tab-billing";
          ErrorEventBus.$emit(
            "update:error",
            InitializeError("Company address is required")
          );
          return false;
        }*/

        if (_this.lodash.isEmpty(_this.propertyAddress)) {
          _this.customerTab = "tab-property";
          ErrorEventBus.$emit(
            "update:error",
            InitializeError("Property address is required")
          );
          return false;
        }

        if (!_this.$refs.customerForm.validate()) {
          return false;
        }

        //_this.formLoading = true;
        _this.$store.dispatch(CLEAR_ERROR, {});

        if (_this.lodash.isEmpty(_this.contactPerson)) {
          _this.contactPerson = await _this.makeDefaultPerson();
        }

        let formData = _this.contactDetail;

        if (_this.lodash.isEmpty(_this.contactDetail.profile_logo) === false) {
          /* formData.profile_logo = _this.contactDetail.profile_logo.id; */
        }
        /*  if (_this.contactDetail.customer_remark) { */
        formData.customer_remark = _this.contactDetail.customer_remark
          ? _this.contactDetail.customer_remark
          : null;
        if (_this.contactDetail.category?.color) {
          formData.category_color = _this.contactDetail.category?.color
            ? _this.contactDetail.category?.color
            : null;
        }
        if (_this.contactDetail.category?.text) {
          formData.category = _this.contactDetail.category?.text
            ? _this.contactDetail.category?.text
            : null;
        }
        /*  } */
        if (_this.lodash.isEmpty(_this.contactPerson) === false) {
          formData.persons = _this.contactPerson;
        }

        formData.lead =
          _this.lodash.toSafeInteger(_this.$route.query.lead) || null;
        formData.proposal =
          _this.lodash.toSafeInteger(_this.$route.query.proposal) || null;
        formData.client_reminders = 0;
        formData.client_follow_up_emails = 0;
        formData.print_email_on_work_order = 0;
        /*  formData.customer_remark = _this.options.remarks; */

        formData.files = _this.attachments;

        if (_this.lodash.isEmpty(_this.notification) === false) {
          formData.client_reminders = _this.lodash.toSafeInteger(
            _this.notification.client_reminders
          );
          formData.client_follow_up_emails = _this.lodash.toSafeInteger(
            _this.notification.client_follow_up_emails
          );
          formData.print_email_on_work_order = _this.lodash.toSafeInteger(
            _this.notification.print_email_on_work_order
          );
          /* formData.customer_remark = _this.lodash.toString(
            _this.notification.customer_remark
          ); */
        }
        if (this.gCreateFormFields && this.gCreateFormFields.length) {
          formData.custom_fields = this.gCreateFormFields;
        }
        _this.formLoading = true;
        try {
          if (!_this.isCustomerCreated) {
            let customerObject = await _this.$store.dispatch(POST, {
              url: "customer",
              data: formData,
            });
            _this.customerId = customerObject.data.id;
            _this.isCustomerCreated = true;
          }
        } catch (error) {
          _this.formLoading = false;
          ErrorEventBus.$emit(
            "update:error",
            "Customer is not created. Please try again."
          );
          return false;
        }

        try {
          if (!_this.isAddressCreated) {
            await _this.createOrUpdatedAddress(_this.customerId);
            _this.isAddressCreated = true;
          }
        } catch (error) {
          _this.formLoading = false;
          ErrorEventBus.$emit(
            "update:error",
            "Property or Company Address is not created. Please try again."
          );
          return false;
        }

        _this.formLoading = false;

        if (_this.isCustomerCreated) {
          _this.$router.push(
            _this.getDefaultRoute("customer.detail", {
              params: { id: _this.customerId },
            })
          );
        }
      } catch (error) {
        ErrorEventBus.$emit("update:error", InitializeError(error));
      }
    },
    getLead() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: "leads/" + _this.leadId,
        })
        .then(({ data }) => {
          _this.lead = data;
          _this.contactPersons = data.persons;
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    // validateForm() {
    //   this.$refs.customerForm.validate();
    // },
  },
  computed: {
    ...mapGetters(["gCreateFormFields"]),
  },
  mounted() {
    this.getOptions();

    this.$refs.customerForm.validate();

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Customer", route: "customer" },
      { title: "Create" },
    ]);

    this.leadId = this.lodash.toSafeInteger(this.$route.query.lead);

    if (this.leadId > 0) {
      this.getLead();
    }
  },
  beforeRouteLeave(to, from, next) {
    const _this = this;
    if (_this.isCustomerCreated) {
      next();
    } else {
      _this.routePreventDialog = true;
      PreventDialogEventBus.$on("stay-on-page", function () {
        _this.routePreventDialog = false;
        next(false);
      });
      PreventDialogEventBus.$on("leave-page", function () {
        _this.routePreventDialog = false;
        next();
      });
    }
  },
};
</script>
<style scoped>
/* tabs css  */

.custom-tab-transparent.v-tabs--fixed-tabs > .v-tabs-bar .v-tab.v-tab--active {
  background-color: #00bcd4 !important;
  color: #fff !important;
  overflow: hidden;
}
.custom-tab-transparent.v-tabs--fixed-tabs
  > .v-tabs-bar
  .v-tab.v-tab--active
  .grey--text.text--darken-4 {
  color: #fff !important;
  caret-color: #fff !important;
}

.custom-tab-transparent.v-tabs .v-tab {
  background: #00bcd429;
  width: 25%;
  clip-path: polygon(
    0% 0%,
    calc(100% - 30px) 0%,
    100% 50%,
    calc(100% - 50px) 150%,
    0% 100%,
    calc(0% + 20px) 50%
  );
}

.custom-tab-transparent.v-tabs .v-tab:first-child {
  clip-path: polygon(
    0% 0%,
    calc(100% - 30px) 0%,
    100% 50%,
    calc(100% - 50px) 150%,
    0% 100%,
    calc(0% + 0px) 50%
  );
}

.custom-tab-transparent.v-tabs .v-tab.v-tab:last-child {
  clip-path: polygon(
    0% 0%,
    calc(100% + -0px) 0%,
    100% 100%,
    calc(100% - 40px) 150%,
    0% 100%,
    calc(0% + 20px) 50%
  );
}
</style>
